
import Vue from "vue";
import AppCustomTable from "@/components/common/CustomTable.vue";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";
import { printHumanFloat } from "@/utils/pretty-print";

export default Vue.extend({
	props: {
		item: {
			type: Object as () => any,
			required: true
		},
		state: {
			type: Object as () => BrowseStateBase,
			required: true
		}
	},
	computed: {
		loaded():boolean {
			return this.state.sidebarItemLoaded;
		},
		suppliers():any[] {
			let suppliers:any[] = [...(this.item.Suppliers || [])];
			return suppliers.sort((a, b)=>(b.IsMainSupplier ? 1 : 0) - (a.IsMainSupplier ? 1 : 0));
		},
		summary():string {
			let main = this.suppliers.find(s=>s.IsMainSupplier) || this.suppliers[0];
			if (!main) return "";
			return `${this.supplierName(main)} · ${this.printFloat(main.NettoPrice)}`;
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		item(){
			this.$emit("summary", this.summary);
		}
	},
	methods: {
		supplierName(supplier:any):string {
			let contact = supplier.Contact;
			if (contact && contact.MainAddress && contact.MainAddress.CompanyOrFullName) {
				return contact.MainAddress.CompanyOrFullName;
			}
			if (contact && contact.ComputedFriendlyID) return contact.ComputedFriendlyID;
			return `#${supplier.ContactID}`;
		},
		printFloat(value:number):string {
			return printHumanFloat(value || 0, 2);
		}
	},
	components: {
		AppCustomTable
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
